<template>
  <page title="Wifi Mall">
<!--    <template v-slot:headleft>-->
<!--      <div class="vcard order-List flex-c" @click="goPackageOrder">-->
<!--        <van-icon name="orders-o" class="flex-c" size='0.65rem' />-->
<!--      </div>-->
<!--    </template>-->

    <div style="position: absolute;bottom: 0;left: 0;right: 0;z-index: 9999" v-if="showPicker">
      <van-picker
        show-toolbar
        :columns="columns"
        :cancel-button-text="i18nConfirm.msg_fail_cancel"
        :confirm-button-text="i18nConfirm.msg_fail_confirm"
        @cancel="showPicker=false"
        @confirm="snConfim"
      />
    </div>

    <div class="page-top-box">
      <div class="search-box">
        <Search v-model="searchText" @handleValue="reload"></Search>
      </div>
      <div class="area padding-h">
        <div class="areaItem" v-for='(key, v,index) in areaList1' @click='goCuntry(v)' :key='key'>
          <div class="areabox">
            <img src="../../assets/imgs/AreaIcon/zy.png" class="areaImg" v-if="index === 0" />
            <img src="../../assets/imgs/AreaIcon/zmz.png" class="areaImg" v-if="index === 1" />
            <img src="../../assets/imgs/AreaIcon/Caribbean.png" class="areaImg" v-if="index === 2" />
            <img src="../../assets/imgs/AreaIcon/oz.png" class="areaImg" v-if="index === 3" />
            <img src="../../assets/imgs/AreaIcon/fz.png" class="areaImg" v-if="index === 4" />
            <img src="../../assets/imgs/AreaIcon/ny.png" class="areaImg" v-if="index === 5" />
            <img src="../../assets/imgs/AreaIcon/xy.png" class="areaImg" v-if="index === 6" />
            <img src="../../assets/imgs/AreaIcon/dny.png" class="areaImg" v-if="index === 7" />
            <img src="../../assets/imgs/AreaIcon/qq.png" class="areaImg" v-if="index === 8" />
            <img src="../../assets/imgs/AreaIcon/dyz.png" class="areaImg" v-if="index === 9" />
            <img src="../../assets/imgs/AreaIcon/nmz.png" class="areaImg" v-if="index === 10" />
            <img src="../../assets/imgs/AreaIcon/dy.png" class="areaImg" v-if="index === 11" />
            <img src="../../assets/imgs/AreaIcon/bmz.png" class="areaImg" v-if="index === 12" />

          </div>
          <div class="areaT" :class="country == v ? 'h-country' : ''">{{ key }}</div>
        </div>
      </div>
    </div>
    <div class="flex-s orderhead-box">
      <div class="equipment-text">{{ i18n.subtitle }}</div>
    </div>
    <div class="scroll-box" ref="scroll" v-infinite-scroll="handleScroll" infinite-scroll-throttle-delay="500"
    infinite-scroll-disabled="busy" infinite-scroll-distance="100">
      <div class="order-item-container">
        <div class="vcard order-item" style="padding: 0;" v-for="item in packagePageList" :key="item.skuId" @click="onSelect(item)">
          <OrderItem :src="item.flagUrl" :width="3.5" :country="item.country" :currencyName="item.currencyName"
            :text="item.text" :price="item.price" :useDay="Number(item.Day)"  >
          </OrderItem>
        </div>
      </div>
      <div style="margin: 20px 0;">
        <van-divider v-if="loadingShow">{{i18n.加载中}}</van-divider>
        <van-divider v-if="noMore">{{i18n.没有更多了}}</van-divider>
      </div>
    </div>
    <div class="activity-foot">
      <div class="go-home" @click="backHome">
        <img src="../../assets/imgs/go_back_home.png" @click="onBack">
        <label class="content">{{i18n.Back_to_home}}</label>
      </div>
    </div>
    <van-dialog v-model="show" title="Package Type" :show-cancel-button="false" :show-confirm-button="false">
      <van-icon name="cross" class="cross-btn" @click="show = false" />
      <div style="max-height: 40vh;overflow: auto;" >
        <div v-for="item in packageDtlList" class="pakage-box flex-s" :class="packageClass(item)"
          @click="selectPack(item)" :key="item.skuId">
          <div class="pakage-title">{{ item.text }}</div>
          <div class="pakage-price">{{ item.currencyName }}{{ item.price }}</div>
          <div class="package-selected flex-c" v-if="packageClass(item) === 'h-pakage'">
            <van-icon name="success" color="#fff" />
          </div>
        </div>
      </div>
      <div class="pakage-num flex-s pakage-title">
        <span>{{ i18n.usagetime }}:</span>
        <span class="checktime" @click="pickerShow = true">{{ myStartime }}</span>
      </div>
      <div class="pakage-num flex-s pakage-title">
        <span>{{ i18n.dayuse }}:</span>
        <span>
          <van-stepper v-model="dayNum" theme="round" button-size="22" disable-input
            :disabled="packageObj.isPackage ? true : false" />
        </span>
      </div>
      <div class="flex-s dialog-bottom">
        <span class="bottom-price">{{ packageObj && packageObj.currencyName || '$' }}{{ price }}</span>
        <van-button @click="onVerify" class="bottom-pakage-btn" round>{{ i18n.Verify }}</van-button>
      </div>
    </van-dialog>
    <van-action-sheet v-model="pickerShow" :title="i18n.usagetime">
      <van-datetime-picker
        v-model="pickerDate"
        type="datetime"
        :min-date="minDate"
        @confirm="datePickerConfirm"
        @cancel="pickerShow = false"
      />
    </van-action-sheet>
    <van-dialog v-model="LoginShow" title="" :show-cancel-button="false" :show-confirm-button="false" width="380px">
      <van-icon name="cross" class="cross-btn" @click="LoginShow = false" />
      <div class="package-title">
        {{i18nConfirm.want_login}}
      </div>
      <div class="tip">
        {{i18nConfirm.enjoy_more_services}}
      </div>
      <div style="text-align: center">
        <van-button @click="login" class="bottom-pakage-btn">{{i18nConfirm.login}}</van-button>
<!--        <van-button @click="toBuy" class="bottom-pakage-btn">{{i18nConfirm.continue_buy}}</van-button>-->
      </div>
    </van-dialog>
    <van-dialog v-model="availableShow" title="" :show-cancel-button="false" :show-confirm-button="false" width="95%" >
      <van-icon name="cross" class="cross-btn" @click="availableShow = false" />
      <div style="margin: 20px;font-size: 32px;color: #333333">{{deviceSn}}</div>
      <div class="scroll-box" style="height: 500px">
        <div style="margin-top: 110px" v-if="orderList.length == 0">
          <van-image :src="require('assets/imgs/device_empt.png')"></van-image>
        </div>
        <div class="how-about" v-for="(item, i) in orderList" :key="i" >
          <div class="refueling">
            <div class="country">
              {{item.country}}
            </div>
            <div class="pack" v-if="item.packageUsage > 0">
              {{i18nConfirm.already_in_effect}}
            </div>
            <div class="unPack" v-else>
              {{ i18nConfirm.not_effective }}
            </div>
          </div>
          <div class="total-refueling">{{item.total}}</div>
          <div class="use-progress">
            <Progress :progress="item.packageUsage/item.packageUsageTotal" :strokeWidth="13" :showInfo="true" />
          </div>
          <div class="refueling-use">
            <div class="used">{{item.packageUsage? item.packageUsage: '--'}}MB {{ i18n.used }}</div>
            <div class="Remaining">{{ i18n.Remaining }} {{item.packageUsageBalance?item.packageUsageBalance:'--'}}MB/{{item.total}}</div>
          </div>
          <div class="use-time">
            <div class="item1">{{i18n.Start_time}}</div>
            <div class="item2">{{item.reserverStartTime}}</div>
          </div>
          <div class="use-time">
            <div class="item1">{{i18n.End_time}}</div>
            <div class="item2">{{item.reserverEndTime}}</div>
          </div>
        </div>
      </div>
    </van-dialog>
  </page>
</template>

<script>
import OrderItem from '../../components/orderItem/orderItem.vue'
import Search from 'components/search/search.vue'
import { areaList } from '@/utils/areaList.js'
import { Debounce } from '@/utils/public.js'
import dayjs from 'dayjs'
import { mapState } from 'vuex'
import Progress from 'components/result/Progress.vue'
import { MIFI_DEVICE, MIFI_PACKAGE_USE, MIFI_DEVICE_SECRET } from '@/apis/cabinet'
import { LOGIN_CODE, SEND_CODE } from '@/apis/user'
export default {
  components: {
    Progress,
    Search,
    OrderItem
  },
  computed: {
    i18n () {
      return this.$t('wifimall')
    },
    i18nConfirm () {
      return this.$t('confirm')
    },
    price () {
      if (this.packageObj && this.packageObj.packageName && this.packageObj.packageName.indexOf('Days') !== -1) {
        return this.packageObj.price
      } else {
        return (Number(this.packageObj.price) * Number(this.dayNum)).toFixed(2)
      }
    },
    ...mapState(['mifiDevices', 'mifisn', 'user'])
  },
  watch: {
    packageObj (val) {
      this.dayNum = val.Day
    },
    searchText (val) {
      this.reload()
    }
  },
  data () {
    return {
      searchText: '',
      areaList1: [],
      show: false,
      pickerShow: false,
      LoginShow: false,
      pickerDate: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      dayNum: 0,
      packagePageList: [],
      packageDtlList: [],
      country: '',
      packageObj: {
        skuId: 0
      },
      minDate: new Date(dayjs().format('YYYY-MM-DD HH:mm:ss')),
      myStartime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      current: 1,
      total: 0,
      type: 'QR',
      loadingShow: false,
      noMore: false,
      columns: null,
      deviceSn: '',
      showPicker: false,
      checkItem: null,
      availableShow: false,
      orderList: [],
      typeMap: {},
      wifiName: '',
      wifiPwd: ''
    }
  },
  created () {
    if (this.$route.query.type) {
      this.type = this.$route.query.type
    }
    if (this.$route.query.deviceSn) {
      this.deviceSn = this.$route.query.deviceSn
    }
    this.getAreaList()
    this.reload()
    if (this.user) {
      this.columns = this.mifiDevices
    //  this.deviceSn = this.mifisn
    }
    this.mifiSecrt()
    this.typeMap = {
      0: this.i18n.type_0,
      1: this.i18n.type_1,
      2: this.i18n.type_2,
      3: this.i18n.type_3,
      4: this.i18n.type_4,
      9: this.i18n.type_9,
      33: this.i18n.type_33,
      88: this.i18n.type_88
    }
  },
  methods: {
    goPackageOrder () {
      this.$router.push('/scanOrder')
    },
    goRouterRePlace (path) {
      this.$router.replace(path)
    },
    datePickerConfirm (value) {
      this.myStartime = dayjs(value).format('YYYY-MM-DD HH:mm:ss')
      this.pickerShow = false
    },
    onVerify () {
      let obj = {
        ...this.packageObj,
        price: this.price,
        selectDays: this.dayNum,
        myStartime: this.myStartime
      }
      this.$store.commit('mifiPackage', obj)
      if (this.type === 'QR') {
        this.$router.replace('/selectPakage?deviceType=mifi')
      } else if (this.type === 'XG' || this.type === 'BXG' || this.type === 'DDXG') {
        this.$router.push('/packageOrder?type=XG')
      } else {
        this.$router.push('/packageOrder?type=GM')
      }
    },
    packageClass (item) {
      return item.skuId === this.packageObj.skuId ? 'h-pakage' : ''
    },
    selectPack (item) {
      this.packageObj = item
    },
    reload () {
      this.current = 1
      this.packagePageList = []
      this.noMore = false
      this.loadingShow = false
      this.onSearch()
    },
    mifiSecrt () {
      var url = `${MIFI_DEVICE_SECRET}${this.deviceSn}`
      this.$get(url, { }, res => {
          if (res.data) {
            console.log(res.data)
            this.wifiName = res.data.wifiSSID
            this.wifiPwd = res.data.wifiPassword
          }
        },
        err => {
          console.log(err)
          this.$toast(err)
        },
        {
          headers: {
            // agentOpenId: !this.isProd ? 'oDn2e4hi8M1iVtXcxm1uYpKTPEBE' : ''
            agentOpenId: 'oDn2e4hi8M1iVtXcxm1uYpKTPEBE' // 正式
          }
        }
      )
    },
    onSearch: Debounce(function () {
      this.$post('chargenow/mifi/query', {
        'requestMethod': 'post',
        'url': '/mifi-open-api/wifiBase/packagePage',
        'data': {
          'size': 20,
          'current': this.current,
          'searchKeywords': this.searchText || this.country
        }
      }, (res) => {
        let data = JSON.parse(res.data).records
        this.total = JSON.parse(res.data).total
        console.log(this.total)
        this.current += 1
        data = data.map(item => {
          item.Day = item.packageName.split('-')[2].includes('Days') ? (item.packageName.split('-')[2]).split('Days')[0] : 1
          if (item.packageName.split('-')[2].includes('Days')) {
            item.text = `${item.packageName.split('-')[1]}/${(item.packageName.split('-')[2]).split('Days')[0]}${this.i18n.天}`
            item.isPackage = 1
            item.total = `${item.packageName.split('-')[1]}`
          } else if (item.packageName.split('-')[2].includes('Unlimited')) {
            item.text = `${this.i18n.无限流量}/${item.Day}${this.i18n.天}`
            item.isPackage = 0
            item.total = `${this.i18n.无限流量}`
          } else {
            item.text = `${item.packageName.split('-')[2]}MB/${this.i18n.天}`
            item.isPackage = 0
            item.total = `${item.packageName.split('-')[2]}`
          }
          return item
        })
        this.packagePageList.push(...data)
        this.loadingShow = false
        console.log(this.packagePageList)
      }, error => {
        console.log(error)
      }, {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      })
    }, 250),
    // 获取地区列表
    getAreaList () {
      this.$post('chargenow/mifi/query', {
        'requestMethod': 'get',
        'url': '/mifi-open-api/wifiBase/regionList',
        'data': ''
      }, (res) => {
        this.areaList1 = res.data ? JSON.parse(res.data) : []
      }, error => {
        console.log(error)
      }, {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      })
    },
    goCuntry (label) {
      this.country = label
      this.searchText = ''
      this.reload()
    },
    handleScroll (e, val) {
      if (this.packagePageList) {
        if (this.packagePageList.length < this.total) {
          this.loadingShow = true
          this.noMore = false
          this.onSearch()
        } else {
          this.noMore = true
        }
      }
    },
    onSelect (item) {
      console.log("4343343434")
      this.checkItem = item
      if (this.user == null) {
        this.LoginShow = true
      } else {
        this.toBuy()
      }
      // this.show = true
      // this.$post('chargenow/mifi/query', {
      //   'requestMethod': 'post',
      //   'url': '/mifi-open-api/wifiBase/packageDtlListBySkuId',
      //   'data': {
      //     'skuId': skuId,
      //     'country': country
      //   }
      // }, (res) => {
      //   this.packageDtlList = JSON.parse(res.data)
      //   this.packageDtlList = this.packageDtlList.map(item => {
      //     item.Day = item.packageName.split('-')[2].includes('Days') ? (item.packageName.split('-')[2]).split('Days')[0] : 1
      //     if (item.packageName.split('-')[2].includes('Days')) {
      //       item.text = `${item.packageName.split('-')[1]}/${(item.packageName.split('-')[2]).split('Days')[0]}天`
      //       item.isPackage = 1
      //     } else if (item.packageName.split('-')[2].includes('Unlimited')) {
      //       item.text = `${this.i18n.无限流量}/${item.Day}${this.i18n.天}`
      //       item.isPackage = 0
      //     } else {
      //       item.text = `${item.packageName.split('-')[2]}MB/${this.i18n.天}`
      //       item.isPackage = 0
      //     }
      //     return item
      //   })
      //   this.packageObj = { ...this.packageDtlList[0] }
      //   console.log('流量套餐列表===', this.packageDtlList)
      // }, error => {
      //   console.log(error)
      // }, {
      //   headers: {
      //     'Content-Type': 'application/json;charset=UTF-8'
      //   }
      // })
    },
    snConfim(value, index) {
      this.showPicker = false
      this.deviceSn = value
    },
    pickClick() {
      if (this.user) {
        this.showPicker = true
      }
    },
    backHome() {
      this.$router.push('/')
    },
    onBack () {
      this.$router.go(-1)
    },
    login() {
      this.$router.push('/otherLogin?deviceSn=' + this.deviceSn)
    },
    toBuy() {
      this.$router.push('/packageOrder?type=2&deviceSn=' + this.deviceSn + '&item=' + encodeURIComponent(JSON.stringify(this.checkItem)))
    },
    packageUse() {
      this.availableShow = true
      let url = `${MIFI_PACKAGE_USE}`
      const headers = {
        headers: { "Content-Type": "application/json;charset=UTF-8" }
      }
      this.$post(
        url, {
          sn: this.deviceSn
        }, (res) => {
          this.$loading(false)
          let data = res.data.records
          data = data ? data.map(item => {
            item.Day = item.packageName.split('-')[2].includes('Days') ? (item.packageName.split('-')[2]).split('Days')[0] : 1
            if (item.packageName.split('-')[2].includes('Days')) {
              item.text = `${item.country}${item.packageName.split('-')[1]}/${(item.packageName.split('-')[2]).split('Days')[0]}${this.i18n.days}`
              item.isPackage = 1
              item.total = `${item.packageName.split('-')[1]}`
            } else if (item.packageName.split('-')[2].includes('Unlimited')) {
              item.text = `${item.country}${this.i18n.无限流量}/${item.Day}${this.i18n.天}`
              item.isPackage = 0
              item.total = `${this.i18n.无限流量}`
            } else {
              item.text = `${item.country}${item.packageName.split('-')[2]}MB/${this.i18n.天}`
              item.isPackage = 0
              item.total = `${item.packageName.split('-')[2]}MB`
            }
            item.packageStatusTitle = this.typeMap[item.packageStatus]
            return item
          }) : []
          // this.orderList.push(...data)
          this.orderList = data
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
        },
        headers
      )
    }
  }
}
</script>

<style lang="less" scoped>
.page-top-box {
  height: auto;
  flex-shrink: 0;
}

.wifi-name{
  font-family: MyFont2;
  font-weight: 400;
  font-size: 28px;
  color: #333333;
}
.wifi-pwd{
  font-family: MyFont3;
  font-weight: bold;
  font-size: 30px;
  color: #21B97C;
  margin-top: 25px;
}
.wifi-box{
  background: #FFFFFF;
  box-shadow: 0px 6px 10px 1px rgba(0,0,0,0.05);
  border-radius: 18px 18px 18px 18px;
  height: 160px;
  display: flex;
  margin: 20px;
}
.scroll-box {
  flex: 1; // flex 1的意思就是 flex-grow 1,这里是缩写 //
  // height: 600px;
  overflow-y: scroll;
}

.areaImg {
  width: 76px;
  height: 76px;
}

.area {
  display: flex;
  overflow-x: scroll;
  margin: 0 auto;
  width: 680px;

  .areaItem {

    // margin: 0 32rpx;
    .areaT {
      width: 150px;
      text-align: center;
      font-family: "Work Sans-Regular";
    }
  }

  .areabox {
    text-align: center;
    width: 140px;
  }
}

.area::-webkit-scrollbar {
  display: none
}

.page-top {
  width: 100%;
  height: 442px;
  background: #FFFFFF;
  border-radius: 4px 4px 100px 100px;
  background-size: cover;
  background-image: url('../../assets/imgs/timg.png');
}

.line-wrap {
  line-height: 3;
}

.page-title {
  text-align: center;
  font-size: 44px;
  font-weight: bold;
  color: #1A2229;
  line-height: 3;
}

.pakage-info {
  font-size: 26px;
  font-weight: 400;
  color: #909090;
  margin-left: 20px;
}

.device-title {
  font-size: 28px;
  font-weight: bold;
  color: #1A2229;
}

.device-info {
  font-size: 24px;
  font-weight: 400;
  color: #666666;
}

.device-img {
  margin-right: 30px;
}

.choose-card {
  background: #CBEDD9;
  border-radius: 18px 18px 18px 18px;
  padding: 20px;
}

.choose-title {
  font-size: 28px;
  font-weight: 600;
  color: #00AB46;
}

.btn {
  width: 100%;
  background: linear-gradient(132deg, #1A2229 0%, #00AB46 100%);
  box-shadow: 0px 6px 10px 1px rgba(49, 200, 137, 0.2);
  border-radius: 60px 60px 60px 60px;
  opacity: 1;
}

.btn-box {
  margin: 76px 40px;
}

.search-box {
  margin: 0 40px 20px 40px;
}

.equipment {
  background: #DBEDE2;
  border-radius: 18px 18px 18px 18px;
  margin: 20px 40px;
  padding: 23px 20px;
}

.equipment-text {
  font-size: 32px;
  font-weight: 600;
  color: #333333;
}

.orderhead-box {
  margin: 40px 40px 20px 40px;
}

.select-btn {
  // position: absolute;
  // right: 20px;
  // bottom: 20px;
  padding: 0 15px;
}

.order-List {
  border-radius: 50%;
  width: 50px;
  height: 50px;
  position: absolute;
  right: 0px;
  top: 10px;
}

.pakage-box {
  margin: 20px;
  position: relative;
  // width: 100%;
  background: #FFFFFF;
  border-radius: 18px 18px 18px 18px;
  border: 1px solid #D1D1D1;
  padding: 17px 20px;

  .pakage-price {
    font-size: 30px;
    font-weight: bold;
    color: #FF1919;
  }
}

.pakage-title {
  font-size: 24px;
  color: #666666;
}

.pakage-num {
  padding: 20px;
  .checktime{
    border: solid 1px #D1D1D1;
    padding: 15px 20px;
    border-radius: 20px;
  }
}

.dialog-bottom {
  padding: 40px 20px;

  .bottom-price {
    font-size: 40px;
    font-weight: bold;
    color: #FF1919;
  }

  .bottom-pakage-btn {
    background: linear-gradient(132deg, #1A2229 0%, #00AB46 100%);
    box-shadow: 0px 6px 10px 1px rgba(0, 171, 70, 0.2);
    border-radius: 60px 60px 60px 60px;
    padding: 23px 73px;
    color: #fff;
  }
}

/deep/.van-icon-orders-o {
  position: unset !important;
  left: unset !important;

}

.order-item-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 每行显示两列 */
  gap: 10px; /* 列与列之间的间距 */
}

.order-item {
  margin-bottom: 0; /* 移除底部外边距 */
  margin: auto;
  max-width: 360px;
}

.h-country {
  color: #00AB46;
  font-weight: 600;
}

.h-pakage {
  border: 3px solid #00AB46;
}

.package-selected {
  width: 46px;
  height: 26px;
  background: #00AB46;
  border-radius: 18px 0px 18px 0px;
  opacity: 1;
  position: absolute;
  right: 0;
  bottom: 0;
}
.device-select{
  text-align: left;
  border-left: 5px solid #036EB8;
  margin-left: 20px;
  margin: 20px;
  label{
    font-weight: bold;
    font-size: 32px;
    color: #333333;
    margin-left: 15px;
  }
}
.info-icon{
  color: #036EB8;
}
.cross-btn{
  position: absolute;
  right: 30px;
  top: 30px;
  font-size: 40px;
}
.flex-s{
  display: flex;
  justify-content: space-between;
  align-items: center
}
.package-title{
  text-align: center;
  padding: 104px 40px 66px 40px;
  font-family: Montserrat, Montserrat;
  font-weight: 400;
  font-size: 28px;
  color: #333333;
}
.tip{
  font-family: Montserrat, Montserrat;
  font-weight: 300;
  font-size: 22px;
  color: #666666;
  text-align: center;
  padding: 20px;
}
.bottom-pakage-btn{
  font-weight: 400;
  font-size: 24px;
  color: #036EB8;
  width: 280px;
  height: 76px;
  border-radius: 40px 40px 40px 40px;
  margin: 30px;
  border: 2px solid #036EB8;
}
.h-pakage {
  border: 3px solid #036EB8;
}
.how-about{
  background: #FFFFFF;
  box-shadow: 0px 4px 16px 1px rgba(0,0,0,0.08);
  border-radius: 18px 18px 18px 18px;
  height: 403px;
  margin: 20px;
  .how-use{
    font-family: Montserrat, Montserrat;
    font-weight: bold;
    font-size: 32px;
    color: #333333;
    text-align: center;
    padding: 30px;
  }
  .row{
    display: flex;
    padding: 12px;
  }
  .num{
    width: 32px;
    height: 32px;
    background: #036EB8;
    border-radius: 50%;
    text-align: center;
    font-family: Montserrat, Montserrat;
    font-weight: 400;
    font-size: 22px;
    color: #FFFFFF;
  }
  .desc{
    padding-left: 12px ;
    font-family: Montserrat, Montserrat;
    font-weight: 400;
    font-size: 22px;
    color: #333333;
    width: 90%;
  }
  .use-progress {
    padding: 10px;
  }
  .refueling{
    display: flex;
  }
  .refueling-use{
    display: flex;
    padding: 20px;
    font-family: Montserrat, Montserrat;
    font-weight: 400;
    font-size: 22px;
    color: #333333;
    .Remaining{
      text-align: right;
      width: 60%;
    }
    .used{
      width: 40%;
    }
  }
  .total-refueling{
    font-family: Montserrat, Montserrat;
    font-weight: normal;
    font-size: 32px;
    color: #333333;
    padding: 30px 0 22px 20px;
    font-weight: bold;
  }
  .country{
    width: 300px;
    min-height: 58px;
    max-height: 98px;
    background: #036EB8;
    border-radius: 18px 0px 18px 0px;
    color: #ffffff;
    font-size: 20px;
    font-family: Montserrat, Montserrat;
    text-align: center;
    align-content: center;
    font-weight: bold;
  }
  .pack{
    font-family: Montserrat, Montserrat;
    font-weight: normal;
    font-size: 24px;
    color: #036EB8;
    font-weight: bold;
    text-align: right;
    width: 70%;
    padding: 15px 20px 0 0;
  }
  .unPack{
    font-family: Montserrat, Montserrat;
    font-weight: normal;
    font-size: 24px;
    color: #999999;
    font-weight: bold;
    text-align: right;
    width: 70%;
    padding: 15px 20px 0 0;
  }
  .use-time{
    display: flex;
    font-family: Montserrat, Montserrat;
    font-weight: 400;
    font-size: 22px;
    color: #666666;
    padding: 20px;
  }
  .item1{
    width: 30%;
  }
  .item2{
    width: 70%;
    text-align: right;
  }
}
.cross-btn{
  position: absolute;
  right: 30px;
  top: 30px;
  font-size: 40px;
}
.activity-foot {
  width: 100%;
  margin: 40px auto 0;
  bottom: 0;
  position: fixed;
  left: 0;
  right: 0;
  text-align: center;
  background: #eeebeb;
  .activation-btn{
    font-family: Montserrat, Montserrat;
    font-weight: bold;
    font-size: 40px;
    color: #FFFFFF;
    border: none;
    width: 670px;
    height: 98px;
    background: #036EB8;
    border-radius: 50px 50px 50px 50px;
    margin-top: 49px;
  }
  .go-home{
    text-align: center;
    width: 100%;
    margin: 21px auto;
    img{
      width: 34px;
      height: 34px;
      vertical-align: -5px;
      display: inline-block;
    }
    .content{
      font-family: Montserrat, Montserrat;
      font-weight: 400;
      font-size: 28px;
      color: #036EB8;
      margin-top: -3px;
    }
  }
}
</style>
